import React from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { FaFilePdf } from "react-icons/fa";
import { IoImage } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";

const DownloadPanel = ({
  activeTabKey,
  t,
  canDownload,
  pdfDownloading,
  pngDownloading,
  csvDownloading,
  isRiskDownloadBusy,
  onDownloadPdf,
  onDownloadPng,
  csvHandlers,
}) => {
  const buttons = [];

  const addPdfPngButtons =
    activeTabKey === "faktuel" || activeTabKey === "performance";
  if (addPdfPngButtons) {
    buttons.push(
      <Button
        key="pdf"
        className="risk-dl-btn risk-dl-btn-pdf"
        variant="contained"
        disableElevation
        startIcon={
          pdfDownloading ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <FaFilePdf />
          )
        }
        onClick={onDownloadPdf}
        disabled={isRiskDownloadBusy}
      >
        {t("downloadPdf")}
      </Button>,
      <Button
        key="png"
        className="risk-dl-btn risk-dl-btn-png"
        variant="outlined"
        disableElevation
        startIcon={
          pngDownloading ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <IoImage />
          )
        }
        onClick={onDownloadPng}
        disabled={isRiskDownloadBusy}
      >
        {t("downloadPng")}
      </Button>,
    );
  }

  if (canDownload) {
    buttons.push(
      <Button
        key="csv"
        className="risk-dl-btn risk-dl-btn-csv"
        variant="outlined"
        disableElevation
        startIcon={
          csvDownloading ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <MdOutlineFileDownload />
          )
        }
        onClick={csvHandlers[activeTabKey]}
        disabled={isRiskDownloadBusy || !csvHandlers[activeTabKey]}
      >
        {t("downloadCsv")}
      </Button>,
    );
  }

  if (!buttons.length) return null;

  return (
    <Box className="risk-analysis-download-card">
      <Typography className="risk-download-title">Downloads</Typography>
      <Box className="risk-download-actions">{buttons}</Box>
    </Box>
  );
};

export default DownloadPanel;
